import {
  InfiniteSearchSelect,
  useInfiniteSearchDataSubjectsQuery,
} from '@atlas-frontend/sdk';

interface DataSubjectFilterInputProps {
  onChange?: (value?: string) => void;
  value?: string;
  selectedSubject?: string;
}

export const DataSubjectFilterInput = (props: DataSubjectFilterInputProps) => {
  const { selectedSubject, ...rest } = props;

  return (
    <InfiniteSearchSelect
      {...rest}
      id="dataSubject-filter"
      searchOptions={selectedSubject}
      useSearchHook={useInfiniteSearchDataSubjectsQuery}
    />
  );
};
